import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import { createStore } from 'redux'
import Analytics from 'react-router-ga'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import reducers from './reducers'

import Root from './Root'
import { CREATE_USER } from './actions'
import { GOOGLE_ANALYTICS } from './config'
import registerServiceWorker from './registerServiceWorker'
import polyfill from './utils/polyfill'

import './Commons.css'

polyfill()

const store = createStore(reducers)
store.dispatch({ type: CREATE_USER })

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Analytics id={GOOGLE_ANALYTICS}>
        <Route path="/:language?" component={Root} />
      </Analytics>
    </Router>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js